exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topMargin10 {\r\n    margin-top: 10px\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./App/containers/userInfo/userInfo.css
// module id = 1316
// module chunks = 0